import * as React from 'react';

import { compose } from 'recompose';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import withFetchLazyImages from 'bundles/page/components/shared/utils/withFetchLazyImages';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!bundles/unified-description-page-common/__styles__/index';

type Props = {
  children?: JSX.Element;
};

const ConsumerPageWrapper = ({ children }: Props) => {
  return (
    <React.Fragment>
      <PageHeader
        {...{
          isPageWithSecondaryCta: true,
          logoWrapper: 'div',
          hideSearch: false,
          hideEnterprise: false,
          hideNotificationCenter: false,
          showShoppingCart: true,
          isScrollable: true,
          showLanguagesDropdown: true,
        }}
      />
      {children}
      <PageFooter isStickyBarPresent />
    </React.Fragment>
  );
};

export default compose<Props, {}>(withMarketingConsent, withFetchLazyImages)(ConsumerPageWrapper);
